import { Badge } from '@/components/ui/badge';
import { StudentGroupStatus, StudentGroupStatusLabelMap } from '@airreading/common/data';
import clsx from 'clsx';

export interface StudentGroupStatusBadgeProps {
  studentGroupLike: { status: StudentGroupStatus };
}

const StatusColorMap: Record<StudentGroupStatus, string> = {
  active: 'bg-emerald-300 text-black',
  archived: '',
};

const StudentGroupStatusVariant: Record<StudentGroupStatus, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  active: 'default',
  archived: 'secondary',
};

export const StudentGroupStatusBadge = ({ studentGroupLike }: StudentGroupStatusBadgeProps) => {
  const { status } = studentGroupLike;

  return (
    <Badge variant={StudentGroupStatusVariant[status]} className={clsx('capitalize', StatusColorMap[status])}>
      {StudentGroupStatusLabelMap[status]}
    </Badge>
  );
};
